import React, { FC } from 'react';
import { TSocialLink, TSocialLinks } from '../types/socialMediaBar.types';
import EELink from './eeLink';
import RegularLink from './regularLink';

const SocialLinks: FC<TSocialLinks> = (props) => {
  const { isEEactive, socialLinksItems, useAnalytics } = props;
  return (
    <>
      {socialLinksItems
        ?.filter((item) => !!(isEEactive || (item?.fields?.icon?.fields?.iconKey?.value && item?.fields?.icon?.fields?.iconUrl?.value)))
        ?.map((item: TSocialLink) => {
          return isEEactive ? (
            <EELink item={item} key={item?.id} />
          ) : (
            <RegularLink
              key={item?.id}
              item={item}
              socialMediaButtonName={item?.fields?.socialMedia?.displayName?.toLowerCase()}
              useAnalytics={useAnalytics}
            />
          );
        })}
    </>
  );
};

export default SocialLinks;
